import React, { lazy, Suspense, useState, useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Link as RouterLink,
  NavLink,
  useLocation,
} from "react-router-dom";
import { event } from "./services/events";
import Seo from "./components/Seo";
import catalog from "./seo-pages.json";
import Estimator from "./pages/Estimator";
import AvisoLegal from "./pages/AvisoLegal";
import Privacidad from "./pages/Privacidad";
import "./styles/rework.css";
const Admin = lazy(() => import("./pages/Admin")),
  Proposal = lazy(() => import("./pages/Proposal"));
function Link({ to, ...props }) {
  const l = useLocation(),
    q = new URLSearchParams(l.search);
  let target = to;
  if (to === "/presupuesto" && q.get("utm_source") === "google")
    target += "?utm_source=google&utm_medium=organic&utm_campaign=gbp";
  return <RouterLink to={target} {...props} />;
}
const services = [
  {
    slug: "mudanzas-locales",
    title: "Mudanzas locales",
    text: "Tu cambio de casa en Madrid y su área metropolitana, preparado desde los accesos hasta la entrega.",
    detail:
      "Una mudanza dentro de la misma localidad también necesita planificación. La distancia es solo una parte: el volumen, la planta, el ascensor, el espacio para el vehículo y el embalaje pueden cambiar el trabajo necesario.",
    items: [
      "Viviendas y traslados de pocos muebles",
      "Inventario, protección y organización de la carga",
      "Revisión de accesos en origen y destino",
    ],
  },
  {
    slug: "mudanzas-nacionales",
    title: "Mudanzas nacionales",
    text: "Traslados entre localidades españolas con un presupuesto que tiene en cuenta el trayecto y la carga.",
    detail:
      "Para organizar una mudanza entre provincias necesitamos conocer las direcciones, el inventario y las fechas. El estimador calcula kilómetros por carretera cuando la ruta se puede verificar. Los trayectos con travesía marítima o condiciones especiales se revisan personalmente.",
    items: [
      "Origen y destino dentro de España",
      "Fecha, disponibilidad y condiciones de entrega por acordar",
      "Islas, Ceuta y Melilla con valoración específica",
    ],
  },
  {
    slug: "mudanzas-oficinas",
    title: "Mudanzas de oficinas",
    text: "Mobiliario y equipamiento de tu negocio, con una planificación adaptada a sus necesidades.",
    detail:
      "Un traslado de oficina requiere ordenar el mobiliario, el equipamiento y la secuencia de trabajo. Indícanos los horarios de acceso, las plantas y los elementos que deben mantenerse identificados. El presupuesto de empresa se revisa personalmente.",
    items: [
      "Inventario por puestos y estancias",
      "Horarios de acceso y coordinación del traslado",
      "Elementos delicados y montaje por valorar",
    ],
  },
  {
    slug: "guardamuebles",
    title: "Guardamuebles",
    text: "Consulta espacio, plazo y condiciones para guardar tus muebles entre una casa y otra.",
    detail:
      "Cuando la salida y la entrada en tu nueva vivienda no coinciden, el guardamuebles puede formar parte de la solución. Para presupuestarlo se revisan volumen, duración, recogida, almacenamiento y segunda entrega. Consulta las condiciones y la disponibilidad antes de contratar.",
    items: [
      "Volumen y tiempo de almacenamiento",
      "Recogida y entrega posterior por presupuestar",
      "Acceso, protección y condiciones por confirmar",
    ],
  },
  {
    slug: "embalaje-montaje",
    title: "Embalaje y montaje",
    text: "Protección de enseres y desmontaje de los muebles que necesitan preparación para el traslado.",
    detail:
      "Puedes preparar tus cajas o solicitar ayuda de embalaje. Indica qué muebles requieren desmontaje y montaje y si hay piezas frágiles, pesadas o de valor. Las necesidades concretas de materiales y manipulación se revisan antes de cerrar el precio.",
    items: [
      "Embalaje completo o parcial",
      "Desmontaje y montaje según el mobiliario",
      "Objetos especiales con valoración personal",
    ],
  },
  {
    slug: "mudanzas-internacionales",
    title: "Mudanzas internacionales",
    text: "Consulta tu traslado fuera de España para una planificación y valoración personal.",
    detail:
      "Los traslados internacionales requieren revisar destino, inventario, transporte y condiciones particulares. Contacta con Britosa para estudiar tu caso. El estimador automático de esta web solo calcula mudanzas con origen y destino en territorio español.",
    items: [
      "Destino e inventario detallados",
      "Plazos y condiciones por acordar",
      "Presupuesto personalizado",
    ],
  },
];
const towns = {
  mostoles: [
    "Móstoles",
    "Móstoles es el punto de partida de Britosa. Para una mudanza dentro del municipio o hacia otra localidad, revisamos las dos direcciones y el trabajo de carga y descarga.",
    "Indica si el traslado es entre barrios de Móstoles o hacia otro municipio. La proximidad no elimina la necesidad de comprobar ascensores y aparcamiento.",
  ],
  "madrid-centro": [
    "Madrid Centro",
    "En el centro de Madrid, preparar el acceso a la vivienda y la posición del vehículo resulta especialmente útil para organizar el traslado.",
    "Cuéntanos el horario disponible, si hay calles con acceso restringido y dónde se puede realizar la carga. Las autorizaciones necesarias se comprobarán para cada dirección.",
  ],
  chamberi: [
    "Chamberí",
    "Una mudanza en Chamberí empieza por conocer las características del edificio y los muebles que deben salir o entrar.",
    "Describe el tamaño del ascensor, los rellanos y el espacio en la escalera. Si una pieza no puede pasar, será necesario revisar la alternativa antes de presupuestar.",
  ],
  alcorcon: [
    "Alcorcón",
    "Para trasladar tu vivienda en Alcorcón, coordinamos la carga en origen con las condiciones de entrega en tu nueva dirección.",
    "Indica garajes, urbanizaciones y recorridos desde el vehículo. Una entrada amplia puede reducir el porte; un recorrido interior largo necesita tiempo adicional.",
  ],
  fuenlabrada: [
    "Fuenlabrada",
    "Britosa estudia traslados de viviendas y oficinas en Fuenlabrada y su conexión con otros municipios.",
    "Separa el mobiliario del resto de cajas en tu inventario e indica qué piezas necesitan desmontaje. Incluye fotografías de los accesos para que podamos revisarlos.",
  ],
  getafe: [
    "Getafe",
    "Organiza tu cambio de vivienda en Getafe con información de las dos casas y del día previsto de la mudanza.",
    "Comunica si la fecha de entrega de llaves y la de salida coinciden. Si necesitas un periodo de guardamuebles, se valorarán también recogida y segunda entrega.",
  ],
  leganes: [
    "Leganés",
    "Una mudanza en Leganés puede ser un traslado cercano o el inicio de un cambio de provincia. El presupuesto depende del trabajo completo.",
    "Añade los bultos de trastero o garaje al inventario. Los objetos que quedan fuera de la vivienda también ocupan espacio y requieren manipulación.",
  ],
  salamanca: [
    "Salamanca, Madrid",
    "En el distrito de Salamanca de Madrid, el inventario y las condiciones del edificio ayudan a preparar la mudanza.",
    "Se trata del distrito madrileño, no de la ciudad de Salamanca. Indica muebles delicados, plantas y posibilidades de estacionamiento para revisar el traslado.",
  ],
  retiro: [
    "Retiro, Madrid",
    "Para una mudanza en el distrito de Retiro, conviene coordinar fecha, acceso al edificio y entrega en el nuevo domicilio.",
    "Comprueba los horarios que permite la comunidad para utilizar el ascensor y realizar el traslado. Comunica cualquier limitación antes de acordar la fecha.",
  ],
  tetuan: [
    "Tetuán",
    "El traslado de una vivienda en Tetuán requiere conocer la calle, el portal y el recorrido de los muebles hasta el vehículo.",
    "Indica si existen desniveles entre calle y portal o puertas estrechas. Una fotografía y las medidas de las piezas grandes ayudan a decidir cómo moverlas.",
  ],
};
function Header() {
  const [open, setOpen] = useState(false);
  const l = useLocation();
  useEffect(() => {
    setOpen(false);
    window.scrollTo(0, 0);
  }, [l.pathname]);
  return (
    <>
      <a className="skip" href="#contenido">
        Saltar al contenido
      </a>
      <header className="header">
        <div className="wrap nav-row">
          <Link className="brand" to="/">
            <img
              src="/assets/images/logo-icon.png"
              width="48"
              height="48"
              alt=""
            />
            <span>
              BRITOSA<small>MUDANZAS</small>
            </span>
          </Link>
          <button
            className="menu-toggle"
            aria-expanded={open}
            aria-controls="main-nav"
            onClick={() => setOpen(!open)}
          >
            Menú
          </button>
          <nav
            id="main-nav"
            className={open ? "open" : ""}
            aria-label="Principal"
          >
            <NavLink to="/servicios">Servicios</NavLink>
            <NavLink to="/nosotros">La empresa</NavLink>
            <a href="/blog/">Guías de mudanza</a>
            <NavLink to="/contacto">Contacto</NavLink>
            <Link className="button" to="/presupuesto">
              Calcula tu mudanza ↗
            </Link>
          </nav>
        </div>
      </header>
    </>
  );
}
function Breadcrumbs() {
  const { pathname } = useLocation();
  const m = catalog[pathname];
  return m && pathname !== "/" ? (
    <nav className="wrap breadcrumbs" aria-label="Ruta de navegación">
      <Link to="/">Inicio</Link> /{" "}
      {pathname.startsWith("/servicios/") && (
        <>
          <Link to="/servicios">Servicios</Link> /{" "}
        </>
      )}
      <span>{m.title.split(" | ")[0]}</span>
    </nav>
  ) : null;
}
function Footer() {
  return (
    <footer>
      <div className="wrap grid three">
        <div>
          <p className="footer-brand">BRITOSA</p>
          <p>
            Mudanzas desde Móstoles.
            <br />
            Madrid y traslados por España.
          </p>
          <a href="tel:+34691604880">691 60 48 80</a>
        </div>
        <div>
          <h2>Prepara tu traslado</h2>
          <Link to="/servicios">Servicios</Link>
          <Link to="/presupuesto">Estimación de mudanza</Link>
          <a href="/blog/">Blog y guías prácticas</a>
          <a
            href="https://maps.google.com/maps?cid=8843951220763584358"
            target="_blank"
            rel="noreferrer"
          >
            Britosa en Google Maps ↗
          </a>
        </div>
        <div>
          <h2>Hablemos</h2>
          <p>Calle Río Duero · Móstoles, Madrid</p>
          <a href="mailto:info@mudanzasbritosa.com">info@mudanzasbritosa.com</a>
          <p>Teléfono: 8:00–22:00, todos los días</p>
        </div>
      </div>
      <div className="wrap footer-bottom">
        <span>© {new Date().getFullYear()} Mudanzas Britosa</span>
        <Link to="/aviso-legal">Aviso legal</Link>
        <Link to="/politica-privacidad">Privacidad</Link>
      </div>
    </footer>
  );
}
function CTA() {
  return (
    <section className="wrap">
      <div className="cta">
        <div>
          <p className="eyebrow">EL SIGUIENTE PASO</p>
          <h2>
            Prepara el cambio.
            <br />
            Nos ocupamos del traslado.
          </h2>
          <p>Empieza con una estimación. Revisaremos contigo los detalles.</p>
        </div>
        <Link className="button light" to="/presupuesto">
          Calcular mi mudanza ↗
        </Link>
      </div>
    </section>
  );
}
function Home() {
  return (
    <>
      <section className="wrap hero">
        <div>
          <p className="eyebrow">MADRID · MÓSTOLES · ESPAÑA</p>
          <h1>
            Tu nueva casa.
            <br />
            <em>Una mudanza bien preparada.</em>
          </h1>
          <p className="intro">
            Cuéntanos qué necesitas trasladar y conoce una estimación
            orientativa. Britosa revisa el inventario y los accesos contigo
            antes de cerrar el presupuesto.
          </p>
          <div className="actions">
            <Link className="button" to="/presupuesto">
              Estimar mi mudanza ↗
            </Link>
            <a className="text-link" href="tel:+34691604880">
              691 60 48 80
            </a>
          </div>
          <p className="fine">
            Primero ves la orientación. Después decides si quieres enviarnos tu
            solicitud.
          </p>
        </div>
        <div className="hero-visual identity-visual">
          <figure className="identity-main">
            <img src="/assets/images/carousel-1.webp" alt="Cajas preparadas para un cambio de hogar" width="1344" height="768" fetchPriority="high" />
          </figure>
          <figure className="identity-detail">
            <img src="/assets/images/carousel-2.webp" alt="Una familia prepara las cajas de su mudanza" width="1344" height="768" />
          </figure>
          <img className="identity-seal" src="/assets/images/logo-icon.png" alt="" width="512" height="512" />
          <div className="visual-note">Tu nueva etapa.<br />Bien preparada.</div>
        </div>
      </section>
      <section className="strip">
        <div className="wrap grid three">
          <p>
            <b>01</b> Direcciones españolas verificadas
          </p>
          <p>
            <b>02</b> Precio orientativo antes del contacto
          </p>
          <p>
            <b>03</b> Presupuesto revisado por el equipo
          </p>
        </div>
      </section>
      <section className="wrap section">
        <div className="section-heading">
          <div>
            <p className="eyebrow">SEGÚN LO QUE NECESITAS</p>
            <h2>
              De una habitación
              <br />a un cambio de ciudad.
            </h2>
          </div>
          <Link to="/servicios">Todos los servicios ↗</Link>
        </div>
        <div className="grid three">
          {services.slice(0, 3).map((s, i) => (
            <Link
              className="card service-card"
              key={s.slug}
              to={"/servicios/" + s.slug}
            >
              <span className="card-number">0{i + 1}</span>
              <h3>{s.title}</h3>
              <p>{s.text}</p>
              <span className="text-link">Ver servicio ↗</span>
            </Link>
          ))}
        </div>
      </section>
      <section className="wrap section identity-gallery" aria-label="Un cambio de hogar bien preparado">
        <figure><img src="/assets/images/carousel-4.webp" alt="Fachada de viviendas en Madrid" width="1344" height="768" loading="lazy" /><figcaption>Madrid y tu próximo destino.</figcaption></figure>
        <figure><img src="/assets/images/carousel-5.webp" alt="Una vivienda lista para recibir los muebles" width="1344" height="768" loading="lazy" /><figcaption>Espacio para tu nueva etapa.</figcaption></figure>
      </section>
      <section className="wrap section editorial">
        <p className="eyebrow">SIN ADIVINAR EL PRECIO</p>
        <h2>
          El volumen importa.
          <br />
          Los accesos, también.
        </h2>
        <p className="intro">
          Una planta sin ascensor, el recorrido a pie o los muebles que
          necesitan desmontaje cambian el trabajo de la mudanza. El formulario
          te ayuda a explicar cada punto para recibir una orientación útil.
        </p>
        <div className="grid three">
          {[
            ["Trayecto", "Origen, destino y fecha prevista."],
            ["Lo que llevas", "Volumen, inventario y servicios adicionales."],
            [
              "Cómo entramos",
              "Plantas, ascensor y distancia hasta el vehículo.",
            ],
          ].map(([t, p]) => (
            <div key={t}>
              <h3>{t}</h3>
              <p>{p}</p>
            </div>
          ))}
        </div>
        <Link className="button" to="/presupuesto">
          Empezar la estimación
        </Link>
      </section>
      <section className="wrap section">
        <p className="eyebrow">ANTES DEL DÍA DE LA MUDANZA</p>
        <h2>Pequeñas decisiones que ayudan.</h2>
        <div className="grid two">
          <a
            className="card"
            href="/blog/como-organizar-una-mudanza-paso-a-paso/"
          >
            <h3>Cómo organizar una mudanza paso a paso</h3>
            <p>
              Inventario, cajas y preparación para llegar al día del traslado
              con un plan.
            </p>
            <span className="text-link">Leer la guía ↗</span>
          </a>
          <Link className="card" to="/servicios/embalaje-montaje">
            <h3>¿Qué preparo yo y qué hace el equipo?</h3>
            <p>
              Consulta embalaje, desmontaje y montaje para acordar el alcance
              del servicio.
            </p>
            <span className="text-link">Preparar los muebles ↗</span>
          </Link>
        </div>
      </section>
      <CTA />
    </>
  );
}
function Services() {
  return (
    <>
      <section className="wrap section">
        <p className="eyebrow">SERVICIOS DE BRITOSA</p>
        <h1>Un traslado adaptado a tu situación.</h1>
        <p className="intro">
          Desde una mudanza cercana hasta un cambio de provincia. Revisamos
          volumen, accesos y servicios para preparar cada presupuesto.
        </p>
        <div className="grid three">
          {services.map((s) => (
            <Link className="card" key={s.slug} to={"/servicios/" + s.slug}>
              <h2>{s.title}</h2>
              <p>{s.text}</p>
              <span className="text-link">Ver detalles ↗</span>
            </Link>
          ))}
        </div>
      </section>
      <CTA />
    </>
  );
}
function Service({ service: s }) {
  return (
    <>
      <section className="wrap narrow section">
        <p className="eyebrow">
          <Link to="/servicios">SERVICIOS</Link> / BRITOSA
        </p>
        <h1>{s.title}</h1>
        <p className="intro">{s.text}</p>
        <img className="service-image" src={s.slug === "mudanzas-nacionales" || s.slug === "mudanzas-internacionales" ? "/assets/images/hero.webp" : s.slug === "guardamuebles" ? "/assets/images/carousel-1.webp" : "/assets/images/carousel-2.webp"} alt={s.slug === "mudanzas-nacionales" || s.slug === "mudanzas-internacionales" ? "Transporte por carretera" : "Preparación del traslado de vivienda"} width="1344" height="768" loading="lazy" />
        <p>{s.detail}</p>
        <h2>Qué necesitamos conocer</h2>
        <ul>
          {s.items.map((t) => (
            <li key={t}>{t}</li>
          ))}
        </ul>
        <h2>Antes de cerrar el presupuesto</h2>
        <p>
          Comparte fotografías del mobiliario y de los accesos. El equipo
          revisará la carga, los servicios incluidos, las posibles limitaciones
          y la fecha. Pide que las condiciones queden reflejadas en la
          propuesta.
        </p>
        <div className="actions">
          <Link className="button" to="/presupuesto">
            Preparar mi solicitud
          </Link>
          <a href="tel:+34691604880">Consultar por teléfono</a>
        </div>
        <h2>Guías para preparar el traslado</h2>
        <p>
          <a href="/blog/como-organizar-una-mudanza-paso-a-paso/">
            Organiza tu mudanza paso a paso
          </a>{" "}
          · <a href="/blog/">Todas las guías</a>
        </p>
      </section>
      <CTA />
    </>
  );
}
function Town({ data: d }) {
  return (
    <>
      <section className="wrap narrow section">
        <p className="eyebrow">MUDANZAS EN MADRID</p>
        <h1>Mudanzas en {d[0]}</h1>
        <p className="intro">{d[1]}</p>
        <h2>Qué revisar para este traslado</h2>
        <p>{d[2]}</p>
        <h2>El precio depende de tu mudanza</h2>
        <p>
          La dirección completa permite identificar el trayecto. El volumen y
          los accesos determinan parte del trabajo; añade ascensor, planta y
          metros de porte a pie de las dos viviendas. El estimador ofrece una
          horquilla provisional cuando dispone de los datos necesarios.
        </p>
        <h2>Servicios que puedes solicitar</h2>
        <p>
          <Link to="/servicios/mudanzas-locales">Traslado local</Link>,{" "}
          <Link to="/servicios/embalaje-montaje">embalaje y montaje</Link> o{" "}
          <Link to="/servicios/guardamuebles">guardamuebles</Link>, según tu
          situación. Cada servicio se revisa antes de cerrar el presupuesto.
        </p>
        <h2>De la solicitud a la propuesta</h2>
        <ol>
          <li>Indica las dos direcciones, el inventario y los accesos.</li>
          <li>
            Consulta la orientación o envía el caso a valoración personal.
          </li>
          <li>
            Britosa revisa las fotos, el alcance y la disponibilidad contigo.
          </li>
        </ol>
        <Link className="button" to="/presupuesto">
          Calcular mi mudanza en {d[0]}
        </Link>
      </section>
      <CTA />
    </>
  );
}
function About() {
  return (
    <>
      <section className="wrap section grid two">
        <div>
          <p className="eyebrow">MUDANZAS BRITOSA</p>
          <h1>
            Desde Móstoles,
            <br />
            hacia tu próxima etapa.
          </h1>
          <p className="intro">
            Britosa realiza mudanzas de viviendas y oficinas, traslados
            nacionales e internacionales y servicios de guardamuebles.
          </p>
          <p>
            El trabajo comienza por conocer qué necesitas mover y cómo son los
            accesos. El embalaje, el desmontaje y el montaje se valoran según
            las características de tus muebles.
          </p>
          <h2>Habla con el equipo</h2>
          <p>
            Cuéntanos la fecha prevista, las direcciones y el inventario.
            Revisaremos las condiciones y la disponibilidad para preparar tu
            propuesta.
          </p>
          <a className="button" href="tel:+34691604880">
            Llamar al 691 60 48 80
          </a>
        </div>
        <figure className="company-photo">
          <img
            src="/assets/images/carousel-3.webp"
            alt="Llaves de una nueva vivienda"
            width="1344"
            height="768"
          />
          <figcaption>Tu hogar, preparado para una nueva etapa.</figcaption>
        </figure>
      </section>
      <CTA />
    </>
  );
}
function Contact() {
  const [message, setMessage] = useState(""),
    [busy, setBusy] = useState(false);
  async function submit(e) {
    e.preventDefault();
    setBusy(true);
    const v = Object.fromEntries(new FormData(e.currentTarget));
    try {
      const r = await fetch("/api/contacto", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(v),
      });
      const j = await r.json();
      if (!r.ok) throw Error(j.message);
      setMessage(j.message);
      e.target.reset();
    } catch (e) {
      setMessage(e.message);
    } finally {
      setBusy(false);
    }
  }
  return (
    <section className="wrap section">
      <p className="eyebrow">HABLEMOS DEL TRASLADO</p>
      <h1>Contacta con Britosa.</h1>
      <div className="grid two">
        <div>
          <h2>¿Tienes una mudanza en mente?</h2>
          <p>
            Para una orientación de precio, comienza por el formulario de
            mudanza. Para otras consultas, llámanos o deja tu mensaje.
          </p>
          <div className="actions">
            <a className="button" href="tel:+34691604880">
              691 60 48 80
            </a>
            <Link to="/presupuesto">Calcular mi mudanza ↗</Link>
          </div>
          <p>
            <a
              href="https://wa.me/34691604880"
              target="_blank"
              rel="noreferrer"
            >
              Consultar por WhatsApp ↗
            </a>
          </p>
          <p>Atención telefónica: todos los días, 8:00–22:00.</p>
          <p>
            Calle Río Duero, Móstoles, Madrid.
            <br />
            Consulta con el equipo antes de desplazarte.
          </p>
          <p>
            <a href="mailto:info@mudanzasbritosa.com">
              info@mudanzasbritosa.com
            </a>
          </p>
          <a
            href="https://maps.google.com/maps?cid=8843951220763584358"
            target="_blank"
            rel="noreferrer"
          >
            Ver el perfil de Britosa en Google ↗
          </a>
        </div>
        <form className="calc-card" onSubmit={submit}>
          <label>
            Nombre
            <input name="nombre" required maxLength="100" />
          </label>
          <label>
            Correo
            <input name="email" type="email" required maxLength="180" />
          </label>
          <label>
            Teléfono opcional
            <input name="telefono" type="tel" maxLength="24" />
          </label>
          <label>
            Tu consulta
            <textarea name="mensaje" rows="5" required maxLength="4000" />
          </label>
          <label className="check">
            <input name="aceptaLOPD" type="checkbox" required value="true" />
            He leído la{" "}
            <Link to="/politica-privacidad">política de privacidad</Link>.
          </label>
          <button className="button" disabled={busy}>
            {busy ? "Enviando…" : "Enviar consulta"}
          </button>
          <p role="status">{message}</p>
        </form>
      </div>
    </section>
  );
}
function App() {
  useEffect(() => {
    const fn = (e) => {
      const href = e.target.closest("a")?.getAttribute("href");
      if (href?.startsWith("tel:")) event("llamada");
      if (href?.startsWith("https://wa.me/")) event("whatsapp");
    };
    document.addEventListener("click", fn);
    return () => document.removeEventListener("click", fn);
  }, []);
  return (
    <BrowserRouter>
      <Seo />
      <Header />
      <Breadcrumbs />
      <main id="contenido">
        <Suspense fallback={<p className="wrap">Cargando…</p>}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/servicios" element={<Services />} />
            {services.map((s) => (
              <Route
                key={s.slug}
                path={"/servicios/" + s.slug}
                element={<Service service={s} />}
              />
            ))}
            {Object.entries(towns).map(([k, d]) => (
              <Route
                key={k}
                path={"/mudanzas-" + k}
                element={<Town data={d} />}
              />
            ))}
            <Route path="/presupuesto" element={<Estimator />} />
            <Route path="/nosotros" element={<About />} />
            <Route path="/contacto" element={<Contact />} />
            <Route path="/aviso-legal" element={<AvisoLegal />} />
            <Route path="/politica-privacidad" element={<Privacidad />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/propuesta/:token" element={<Proposal />} />
            <Route
              path="*"
              element={
                <section className="wrap section">
                  <h1>Página no encontrada</h1>
                  <Link to="/">Volver a inicio</Link>
                </section>
              }
            />
          </Routes>
        </Suspense>
      </main>
      <Footer />
    </BrowserRouter>
  );
}
export default App;
